import LoadingCurl from './LoadingCurl';

export default LoadingCurl;
